import './utils/prepare';
import './utils/debug';
import './utils/native-polyfill';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import CoreRouter from 'core/Router';
import bbtNative from '@bbtfe/native';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { useGlobalOption, ErrorBoundary } from '@bbt/react-components';
import './styles/index.scss';
import 'antd-mobile/dist/antd-mobile.css';
// import '@bbtfe/balsa-comp/dist/balsa-components-library-cjs/componentsList.css'
import { sendCustomEvent } from './utils/volcengine';
import { Provider, Contexts } from './context';
import { UAParser } from '@utils';
import { getHostEnv } from '@utils/config';

useGlobalOption({
  px2rem: px => {
    return `${(px / 100).toFixed(2)}rem`;
  }
});

dayjs.extend(duration);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

window.bbtNative = bbtNative;

const Ready = () => {
  const { dispatch } = Contexts();
  useEffect(() => {
    const handleClick = (event) => {
      const env = getHostEnv(); // 环境
      if(env==='local')return;
      let clickedElement = event.target;
      while (clickedElement !== document) {
        if (clickedElement.hasAttribute('name')) {
          // 找到带有name属性的元素，触发相应的处理逻辑
          // 你可以在这里编写点击事件的处理逻辑
          break;
        }
        clickedElement = clickedElement.parentNode;
      }
      if(!clickedElement.getAttribute){
        return;
      }
      const name = clickedElement.getAttribute('name');
      const psindex=clickedElement.getAttribute('psindex')||0;
      const poindex=clickedElement.getAttribute('poindex')||0;
      if (name) {
        const trackingOptions = {
          an: 2,
          ii: name, // 栏位ID
          ps: psindex, // 区域内横向顺位如左数第X个
          po: poindex, // 区域内纵向顺位，如向下第Y个
        };
        trackingSend(trackingOptions);
      }
    };
    document.body.addEventListener('click', handleClick);
    return () => {
      document.body.removeEventListener('click', handleClick);
    };
  }, []);
  useEffect(() => {
    bbtNative.ready(() => {
      dispatch({
        type: 'upgrade',
        payload: {
          userAgent: UAParser()
        }
      });
    });
  }, []);
  return null;
};

ReactDOM.render(
  <ErrorBoundary
    onError={error => {
      console.log('error', error);
      sendCustomEvent({
        name: '组件全局异常',
        categories: {
          message: error?.message,
          stack: error?.stack
        }
      });
    }}
  >
    <Provider>
      <Ready />
      <CoreRouter />
    </Provider>
  </ErrorBoundary>,
  document.getElementById('app'),
  () => {
    bbtNative.ready(() => {
      const token = bbtNative.isApp() ? bbtNative?.userinfo?.loginString : '';
      if (token && window.apmPlus) {
        window.apmPlus('config', {
          userId: token
        });
      }
    });
  }
);
